module.exports = __webpack_public_path__ + "img/red_diode-copy.66a8e3f0.png";